import { render, staticRenderFns } from "./defaultLayout.vue?vue&type=template&id=fe057648&"
import script from "./defaultLayout.vue?vue&type=script&lang=js&"
export * from "./defaultLayout.vue?vue&type=script&lang=js&"
import style0 from "./defaultLayout.vue?vue&type=style&index=0&id=fe057648&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports